export default "__VITE_ASSET__EnPzkwLUG1oMNb6LawlSsg__"